import React from 'react';
import { Box, TextV2, ButtonV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';

interface UnpublishedWebsiteBannerProps
  extends Readonly<{
    onPublish: () => void;
    isPublishing: boolean;
  }> {}

const UnpublishedWebsiteBanner: React.FC<UnpublishedWebsiteBannerProps> = ({ onPublish, isPublishing }) => {
  const { tq } = useTranslation('publishReminder');
  const isMobile = useIsMobileScreen();

  return (
    <Box
      display="flex"
      backgroundColor="newUIBrandPrimary"
      width="100%"
      zIndex={3001}
      position="fixed"
      top={0}
      alignItems="center"
      justifyContent="center"
      paddingX={5}
      paddingY={[3, null, 4]}
      gap={[4, null, 5]}
    >
      <TextV2
        typographyVariant="label3"
        color="white"
      >
        {isMobile
          ? tq`Your website is hidden from guests for now. Publish before sharing.`
          : tq`Your website is hidden from guests for now. Publish it when you're ready to share.`}
      </TextV2>
      <ButtonV2
        variant="outline"
        typographyVariant="label3"
        onClick={onPublish}
        color="white"
        borderColor="white"
        shape="rounded"
        _hover={{ color: 'white', borderColor: 'white' }}
        _active={{ color: 'white', borderColor: 'white' }}
        loading={isPublishing}
      >
        {tq`Publish Website`}
      </ButtonV2>
    </Box>
  );
};

UnpublishedWebsiteBanner.displayName = 'UnpublishedWebsiteBanner';

export { UnpublishedWebsiteBanner };
